export const SpaceRouteMarker = '__monospace_space_route_marker__';
export const SpacePageRouteMarker = '__monospace_space_page_route_marker__';
